import { render, staticRenderFns } from "./maintenanceRecords.vue?vue&type=template&id=90746f16&"
import script from "./maintenanceRecords.vue?vue&type=script&lang=js&"
export * from "./maintenanceRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports